module.exports = __webpack_public_path__ + "img/hat-logo-transparent.f00df491.png";